import {RESERVATION_PAYMENT_TYPES} from '@guestapp/sdk';

const PAYMENT_ITEMS_WITH_MORE_INFO_MODAL = [
  RESERVATION_PAYMENT_TYPES.damageProtection,
  RESERVATION_PAYMENT_TYPES.touristTaxes,
  RESERVATION_PAYMENT_TYPES.securityDeposit,
];

export {PAYMENT_ITEMS_WITH_MORE_INFO_MODAL};
